import '../../styles/blocks/_product.scss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { animateScroll } from 'react-scroll';
import { TRADITIONAL } from 'constants/userProfile';
import { InitialStepDispatcher } from 'components/newAccountSteps/initialStep/InitialStepDispatcher';
import { recordInitialPage, recordedInitialPage, getRecordedInitialPage } from 'utilities/uTagging';
import { PATH_OPEN_YOUR_ACCOUNT } from 'constants/uTagConstants/paths';

class Initial extends Component {
    constructor(props) {
        super(props);

        this.state = {
            animateClassName: '',
        };
    }

    UNSAFE_componentWillMount() {
        setTimeout(() => {
            this.setState({
                animateClassName: 'animation-fade--show',
            });
            this.props.changeHeight('initial');
            this.props.changeHeight('information');
        }, 1000);

        animateScroll.scrollTo(0, { duration: 500 });
    }

    componentDidMount() {
        const { userProfile, products, formActions } = this.props;
        if (!getRecordedInitialPage()) {
            recordedInitialPage();
            const { investmentType } = userProfile;
            const invite = userProfile.jointHolderData.invite;
            let jointHolderAccount;
            if (invite.jointHolderType) {
                jointHolderAccount = {
                    isJointHolderAccount: '',
                    typeHolder: invite.jointHolderType,
                    typeUserHolder: 'no cliente',
                };
            }
            formActions.change('userProfile.investmentType', TRADITIONAL);
            recordInitialPage(
                PATH_OPEN_YOUR_ACCOUNT,
                userProfile.product,
                products.get('productsDescription'),
                jointHolderAccount,
                investmentType ? investmentType : ''
            );
        }
        formActions.change('userProfile.investmentType', TRADITIONAL);
    }

    render() {
        const className = `joint-holder-initial animation-fade ${this.state.animateClassName}`;
        return (
            <div id="joint-holder-initial" className={className}>
                <div className="prospects-step-content basic-layering">
                    <InitialStepDispatcher promoCode={null} promotionalCode={this.props.promotionalCode} />
                </div>
            </div>
        );
    }
}

module.exports.constructor = Initial;
module.exports.Initial = connect(
    state => ({
        promotionalCode: state.promotionalCode,
        initialStep: state.initialStep,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(Initial);
